import { useEffect, useRef, useState } from "react";
import { loadWafCaptcha } from "utils/wafCaptcha";

export default function useCaptcha({ onLoad, onSuccess } = {}) {
  const [showCaptcha, setShowCaptcha] = useState(false);
  const [isCaptchaLoading, setIsCaptchaLoading] = useState(false);
  const [isCaptchaSuccess, setIsCaptchaSuccess] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const captchaBoxRef = useRef(null);

  useEffect(() => {
    loadWafCaptcha();
  }, []);

  useEffect(() => {
    function renderCaptcha() {
      if (window.AwsWafCaptcha) {
        window.AwsWafCaptcha.renderCaptcha(document.getElementById("captchaForm"), {
          onLoad: () => {
            setIsCaptchaLoading(false);
            onLoad?.();
          },
          onSuccess: () => {
            setShowCaptcha(false);
            setIsCaptchaSuccess(true);
            onSuccess?.();
          },
          apiKey: process.env["REACT_APP_WAF_CAPTCHA_KEY"]
        });
      }
    }

    if (anchorEl) {
      const timer = setTimeout(() => {
        renderCaptcha();
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [anchorEl, onLoad, onSuccess]);

  function handleCaptchaClick() {
    setIsCaptchaLoading(true);
    setShowCaptcha(true);
    setAnchorEl(captchaBoxRef.current);
  }

  function handleCaptchaClose() {
    setShowCaptcha(false);
    setAnchorEl(null);
  }

  return {
    showCaptcha,
    isCaptchaLoading,
    isCaptchaSuccess,
    anchorEl,
    captchaBoxRef,
    handleCaptchaClick,
    handleCaptchaClose
  };
}
